module.exports = __webpack_public_path__ + "static/media/photo114.782e7a78.jpg";